import { render, staticRenderFns } from "./HomeworkDetailsModal.vue?vue&type=template&id=0a44bd32&scoped=true"
import script from "./HomeworkDetailsModal.vue?vue&type=script&lang=js"
export * from "./HomeworkDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./HomeworkDetailsModal.vue?vue&type=style&index=0&id=0a44bd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44bd32",
  null
  
)

export default component.exports